// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PQse","tableHeader":"styles_tableHeader__1JveN","tableHeaderCell":"styles_tableHeaderCell__1OyDw","tooltip":"styles_tooltip__3MUlI"};